export enum WebEventNames {
  // notification
  NOTIFICATION_VIEW = 'notification.view',
  NOTIFICATION_PUBLIC_ENTER_NOTIFICATION = 'notification.public.enter-notification',
  NOTIFICATION_PRIVATE_ENTER_NOTIFICATION = 'notification.private.enter-notification',
}
